// extracted by mini-css-extract-plugin
export default {"root":"PersonalInfoView_root__V97Ep","panel":"PersonalInfoView_panel__UC+Qy","wrapper":"PersonalInfoView_wrapper__K1Jdo"};